<template>

<div id="card-details">
    <div id="info">
        <h4 class="title"><i class="pl-3 fas fa-clipboard-list"></i> RESUMO</h4>
    </div>
    <div class="card-details-body mt-4 ml-3">

        <div id="footer-card-details" class="w-100">
            <p class="label-result-name"><i class="fas fa-sign"></i> {{this.edit.nome}} </p>
        </div>

        <div>
            <p class="label-details-title margem">Status</p>
            <div class="status-content" :style='statusColor'>{{statusText}}</div>
        </div>

        <div>
          <div class="label-details-title margem">Quantidade de empreedimentos</div>
          <div class="label-details">{{this.edit.countEmpreendimento}}</div>
        </div>

        <div>
            <div class="label-details-title margem">Cidade</div>
            <div class="label-details">{{this.edit.cidade.nome}}</div>
        </div>

        <div>
            <div class="label-details-title margem">UF</div>
            <div class="label-details">{{this.edit.cidade.estado.sigla}}</div>
        </div>

        <div>
          <p class="label-details-title margem">Data de Cadastro</p>
          <div class="label-details">{{this.edit.dataCadastroFormatada}}</div>
        </div>

    </div>
</div>

</template>

<script>
import Abstractaccredited from './abstractaccredited'
export default Abstractaccredited
</script>

<style scoped>
@media (min-width: 800px ) and (max-width: 1400px) {
  .label-result-name{
      color: #5a5a5a;
      font-size: 17px;
      font-weight: 700;
      line-height: 30px;
      font-family: Segoe UI;
  }
}

@media (min-width: 1401px ){
  .label-result-name{
    color: #5a5a5a;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
  }
}
#card-details{
  width: 100%;
  border: 1px solid rgb(202, 202, 202);
  background-color: white;
  border-radius: 5px;
  height: 100%;
}
#info{
  height: 50px;
  width: 100%;
  font-size: 20px;
  background-color: #008148;
  color: white;
}

.margem{
  margin-bottom: 0.3rem;
}
.card-details-body{
  margin-left: 0.5vw;
  display: flex;
  flex-direction: column;
  gap: 15px
}

.field-summary{
  column-gap: 1rem;
}

.linha{
  width: 95%;
}

.title{
  height: 50px;
  width: 100%;
  font-size: 18px;
  background-color: #008148;
  padding-top: 15px;
  color: white;
}

.icone{
  margin-left: 3%;
  margin-top: 3%;
  color: white;
}

.label-accredited{
  font-size: 23px;
  color: #272626;
  opacity: 90%;
}

.label-details{
    font-size: 15px;
    color: #2a2a2a;
}

.label-details-title{
    gap: 0.3rem;
    font-size: 13px;
    color: #666;
    font-weight: 600;
}

.field-label{
  font-size: 15px;
  color: #4F4C4D;
  margin-bottom: 0px;
}

.button-status{
margin-bottom: 3%;
width: 86px;
height: 25px;
/* UI Properties */
background: #30A75F 0% 0% no-repeat padding-box;
border-radius: 16px;
opacity: 1;
}

.button-name{
color: white;
font: normal normal 600 15px/20px Segoe UI;
margin-left: 28%;
}

.status-content{
  /* background-color: #30a75f; */
  width: fit-content;
  color: white;
  border-radius: 16px;
  padding: 5px 20px;

  display:table; /* keep the background color wrapped tight */
  padding:5px;
  padding-left: 20px;
  padding-right: 20px;
  font-size:15px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/components/abstractaccredited/abstractaccredited.vue